import * as types from '../../constants/actionTypes';
import { userAccountService } from '../../api/userAccountService';

export function login(username, password) {
    return function (dispatch) {
        dispatch(request({ username }, types.USER_ACCOUNT_LOGIN_REQUEST));
        return userAccountService.login(username, password).then(response => {
            dispatch(success(response, types.USER_ACCOUNT_LOGIN_SUCCESS));
            return response;
        }).catch(error => {
            dispatch(failure(error, types.USER_ACCOUNT_LOGIN_FAILURE));
        });
    };
}

export function logout() {
    userAccountService.logout();
    return { type: types.USER_ACCOUNT_LOGOUT };
}

function request(user, types) { return { type: types, user } }
function success(response, types) { return { type: types, response } }
function failure(error, types) { return { type: types, error } }